export const saasExplainerVideos = [
  {
    id: "01",
    title: { ar: "Revolut Bank", en: "Revolut Bank", fr: "Revolut Bank" },
    subtitle: { ar: "بنك بريطاني", en: "British bank", fr: "Banque britannique" },
    src: "/saas-explainers/revolut-bank.mp4",
    poster: "/saas-explainers/revolut-bank-poster.webp",
  },
  {
    id: "02",
    title: { ar: "Voursa", en: "Voursa", fr: "Voursa" },
    subtitle: { ar: "منصة موريتانية للبيع والشراء", en: "Mauritanian marketplace", fr: "Place de marché mauritanienne" },
    src: "/saas-explainers/voursa.mp4",
    poster: "/saas-explainers/voursa-poster.webp",
  },
  {
    id: "03",
    title: { ar: "Master Voyages", en: "Master Voyages", fr: "Master Voyages" },
    subtitle: { ar: "السفر وحجز الرحلات", en: "Travel and trip booking", fr: "Voyages et réservation de séjours" },
    src: "https://ik.imagekit.io/yacoubCreates/yacoubcreates/saas-explainers/master-voyages_kjs1O0Bmx.mp4",
    poster: "https://ik.imagekit.io/yacoubCreates/yacoubcreates/saas-explainers/master-voyages-poster_gbkW6Z_U5.webp",
  },
];
